import EADialog from "../../EADialog";
import React, {useEffect, useState} from "react";
import {useForm} from "../../../utils/FormUtils";
import EAButton from "../../EAButton";
import EATable from "../../EATable";
import {createCalculatedColumn, createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import {range} from "lodash";
import IconButton from "@material-ui/core/IconButton";
import {Cancel} from "@material-ui/icons";
import {processVeranlagungen} from "../../../services/AbwasserbeseitigungspflichtigeService";

export default function AbwasserbeseitigungspflichtigeDialog({
                                                                 open,
                                                                 readonly,
                                                                 veranlagungen,
                                                                 selectableAbwasserbeseitigungspflichtige,
                                                                 onClose,
                                                                 anlageId
                                                             }) {
    const initialValues = {
        jahr: {id: new Date().getFullYear(), value: new Date().getFullYear()}
    };

    const [editedVeranlagungen, setEditedVeranlagungen] = useState(veranlagungen);
    const {values, setValues, setErrors, formFactory} = useForm({
        initialValues: initialValues
    });

    // Close wird immer aufgerufen, wenn der Dialog geschlossen wird, d.h. sowohl beim Klick auf den
    // "Übernehmen"-Button als auch auf den "Schließen"-Button in der oberen rechten Ecke
    const handleClose = () => {
        setValues(initialValues);
        setErrors({});

        const currentAbwasserbeseitigungspflichtiger = editedVeranlagungen[0] ? editedVeranlagungen[0].organisation.bezeichnung : "";
        onClose(currentAbwasserbeseitigungspflichtiger, editedVeranlagungen);
    };

    const handleAdd = () => {
        const newItem = {
            organisation: values.organisation,
            abwasseranlage: {id: anlageId},
            startJahr: values.jahr.value,
        };

        if (validate(newItem)) {
            const items = editedVeranlagungen.slice();
            items.push(newItem);
            processVeranlagungen(items);
            setEditedVeranlagungen(items);
            setErrors({});
        }
    };

    const validate = (newItem) => {
        if (!newItem.organisation) {
            setErrors({organisation: "Es muss ein Abwasserbeseitigungspflichtiger ausgewählt werden"})
            return false;
        }

        const hasDuplicateYears = editedVeranlagungen.some(item => item.startJahr === newItem.startJahr)
        if (hasDuplicateYears) {
            setErrors({jahr: "Für das angegebene Jahr ist bereits eine Veranlagung angelegt"});
            return false;
        }

        const veranlagungIsAlreadyPresent = editedVeranlagungen.filter(item => item.organisation.id === newItem.organisation.id && item.startJahr === newItem.startJahr).length > 0;
        if (veranlagungIsAlreadyPresent) {
            setErrors({organisation: "Die Veranlagung wurde bereits angelegt"})
            return false;
        }

        return true;
    }

    const handleRemove = (index) => {
        const items = editedVeranlagungen.slice();
        items.splice(index, 1);
        processVeranlagungen(items);
        setEditedVeranlagungen(items);
    };

    const selectableYears = range(1950, (new Date().getFullYear() + 1)).map(item => {
        // Select-Component verlangt Objekte mit Attributen "id" und "value",
        // daher müssen für die Auswahl entsprechende Objekte angelegt werden
        return {
            id: item,
            value: item
        }
    });

    const tableColumns = [
        createCalculatedColumn("organisation", (row) => row.organisation.value ? row.organisation.value : row.organisation.bezeichnung, "Abwasserbeseitigungspflichtiger"),
        createColumn("zeitraum", "im Zeitraum"),
    ];

    if (!readonly) {
        tableColumns.push(
            createComponentColumn("remove", (row, index) => {
                return (
                    <IconButton size="small" onClick={() => handleRemove(index)}>
                        <Cancel/>
                    </IconButton>
                );
            })
        );
    }

    useEffect(() => {
        processVeranlagungen(editedVeranlagungen);
        setEditedVeranlagungen(editedVeranlagungen);
    }, [editedVeranlagungen]);

    return (
        <EADialog open={open}
                  closeFunction={handleClose}
                  titleChildren={<p>Abwasserbeseitigungspflichtigen zuweisen</p>}
                  content={
                      <div className="gridl" style={{width: "50em"}}>
                          {!readonly && <div className="gridl" style={{gridTemplateColumns: "auto 11em 10em"}}>
                              {formFactory.renderAutocomplete("organisation", "organisation", "Abwasserbeseitigungspflichtiger", selectableAbwasserbeseitigungspflichtige, "bezeichnung")}
                              {formFactory.renderSelect("jahr", "jahr", "Ab Veranlagungsjahr", selectableYears)}
                              {formFactory.renderButton("hinzufuegen", "hinzufuegen", "Hinzufügen", handleAdd)}
                          </div>
                          }
                          <div>
                              <EATable
                                  id="abwasserbeseitigungspflichtige-dialog-table"
                                  loading={false}
                                  initialSortColumn="zeitraum"
                                  columns={tableColumns}
                                  data={editedVeranlagungen}
                              />
                          </div>
                      </div>
                  }
                  buttons={<EAButton id="close" label="Schließen" onClick={handleClose}/>}
        />
    );
}
